var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"criteria-label d-block"},[_vm._v(" Describa los criterios y procedimientos que se utilizarán para evaluar el progreso del estudiante: ")]),_c('span',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }